import { Container, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { RemindersSnapshotsTable } from "./components";

export const View = () => {
  const { t } = useTranslation();

  return (
    <Container fluid>
      <Title mt="xl" mb="xl" weight={500} order={3}>
        {t("REMINDERS")}
      </Title>

      <RemindersSnapshotsTable weekOnly />
    </Container>
  );
};
